/**
 * Created by mestrad on 2018. 06. 28..
 */

export default Search;

import BrowserHistory from "../BrowserHistory";
import Common from "../Common";
import Style from "../Style";
import SearchRequest from "./Request";
var previouslyInit = false;

const $ = jQuery;

function Search(config) {
    var page;
    var limit;
    BrowserHistory.init(config);

    // Csak egyszer fusson le az init
    if (!previouslyInit) {
        init();
        previouslyInit = true;
    }

    function createCookie(name, value, days) {
        var expires;

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        } else {
            expires = "";
        }
        document.cookie = encodeURIComponent(name) + "=" + encodeURIComponent(value) + expires + "; path=/";
    }

    function readCookie(name) {
        var nameEQ = encodeURIComponent(name) + "=";
        var ca = document.cookie.split(';');
        for (var i = 0; i < ca.length; i++) {
            var c = ca[i];
            while (c.charAt(0) === ' ')
                c = c.substring(1, c.length);
            if (c.indexOf(nameEQ) === 0)
                return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
        return null;
    }

    function eraseCookie(name) {
        createCookie(name, "", -1);
    }

    function init() {
        var id = Common.getUrlParam("id") || config.id;
        var actualDate = Common.getUrlParam("date");
        page = config.page == undefined ? 1 : config.page;

        /**
         * Visszalépéskor az előző oldalszámmal
         * jelenítsük meg a keresési találatokat
         * https://hermeszsoft.atlassian.net/browse/ONN-1679
         */
        var lastPage = readCookie('previousPage');
        var lastUrl = readCookie('previousUrl');
        if (lastPage != null && lastUrl != null && lastUrl == window.location.href) {
            page = parseInt(lastPage);
            createCookie('previousPage', 1, 0.2);
        }
        limit = $("#pagination-pagesize option:selected").val() == undefined ? 50 : $("#pagination-pagesize option:selected").val();

        // Kiegészítés szép url-ekre is
        var prettyUrl = /(person|geo|corporate|memorial)\/[\d]+\/$/.test(window.location.href);
        if (!id && !actualDate && !prettyUrl) {
            Style.show($(config.domElements.searchWidget));
        }
        initEvents();
        loadForm();
        if (Common.getUrlParam("search", window.location) !== undefined) {
            if ( +Common.getUrlParam( 'load', window.location ) !== 1 ) {
                $(config.domElements.searchSubmitBtn).trigger("submit");
            }
        }

        $(window).on('keypress', function(e){
            if (e.keyCode === 13 &&
                $('#nnp_search_form').is(':visible') &&
                !$('.dialog-widget').is(':visible') &&
                !$('.select2-container--open').is(':visible') ) {
                e.preventDefault();
                $('#nnp_search_form').submit();
            }
        });

        createCookie('previousUrl', window.location.href, 0.2);
    }

    function initEvents() {
        $( '#customSearchWrapper' )
            .on( 'change', 'select[id^="nnpSearchFilterTypes"]',
                function ( e ) {
                    var $select = $( this );
                    var $selectResizeHelper = $( '#select_resize-helper' );
                    if ( $selectResizeHelper.length === 0 ) {
                        $selectResizeHelper =
                            $( '<div' + ' id="select_resize-helper"/>' )
                                .appendTo( $select.parent() );
                    }
                    var text = $select.children( 'option:selected' ).text();
                    var height = $selectResizeHelper.text( text ).height();
                    $select.height( height );
                    $selectResizeHelper.remove();
                    $( e.target )
                        .find( 'option[value="-1"]' )
                        .prop( 'disabled', true );
                    $( e.target )
                        .next()
                        .find( 'select' )
                        .eq( 0 )
                        .removeProp( 'disabled' );
                    $( e.target ).next().find( 'input:not(.hasDatepicker)' ).eq( 0 ).focus();
                } )
            .on( 'focus', 'select[id^="nnpSearchFilterTypes"]', function ( e ) {
                $( e.target )
                    .next()
                    .find( 'select' )
                    .eq( 0 )
                    .prop( 'disabled', true );
            } );

        $('#' + config.domElements.mainPageSearch.inputId).on('keypress', function(e){
            if (e.keyCode === 13) {
                e.preventDefault();
                initMainPageSearch();
                /*
                var searchInput = $('#' + config.domElements.mainPageSearch.inputId);
                searchInput.removeClass("ui-state-error");
                searchInput.parent().children(".nnp_error_message").remove();
                searchInput.addClass("ui-state-error");
                searchInput.parent().append('<div class="nnp_error_message">Válassza ki melyik névtérben kíván keresni.</div>');
                */
            }
        });
        $(document).on('mouseover', '#' + config.domElements.mainPageSearch.inputId, function(){
            $('.nnp-search2-tooltip').fadeIn(200);
        });
        $(document).on('mouseout', '#' + config.domElements.mainPageSearch.inputId, function(){
            $('.nnp-search2-tooltip').fadeOut(200);
        });
        $(config.domElements.searchForm).on("submit", function (e) {
            e.preventDefault();
            $.extend(config, {
                page: page,
                limit: limit
            });
            if (!validateForm()) return;
            var $form = $( config.domElements.searchForm );
            $(config.domElements.searchForm).trigger("getExtraFilters");

            var extended = {};
            var myUrlWithParams = new URL(
                `${ window.location.protocol }//${ window.location.host }${ window.location.pathname }` );
            myUrlWithParams.searchParams.set(
                'search', document.getElementById( 'nnp_search' ).value
            );
            if ( !! $( config.domElements.wrapperSelector ).find( 'select' ).length ) {
                Object.entries( $form.data( 'custom_filter' ) ).forEach(
                    ( [ filterType, filters ] ) => extended[ filterType ] =
                        ! filters.hasOwnProperty('coordinates') ?
                        filters.map( filterValue => {
                            const items =
                                Array.isArray( filterValue.items ) ?
                                filterValue.items.map( itemId => [
                                    itemId,
                                    $( `select[id^=nnpSearchFilterOptions] option[value=${ itemId }]` ).text() ||
                                    $( `select[id^=nnpSearchFilterInput] option[value=${ itemId }]` ).text()
                                ] ) :
                                filterValue.items;
                            return { ...filterValue, items };
                        } ) : filters
                    );

                myUrlWithParams.searchParams.set( 'custom_filter', JSON.stringify( extended ) );
                window.history.pushState(
                    {}, '', myUrlWithParams.search !== '?search=' &&
                            !! Object.values( myUrlWithParams.searchParams ).length
                            ? myUrlWithParams.search
                            : myUrlWithParams.href
                );
            }

            if ( ! Object.values( $form.data( 'custom_filter' ) ).length ) {
                window.history.pushState(
                    {}, '', myUrlWithParams.search !== '?search=' &&
                        !! Object.values( myUrlWithParams.searchParams ).length
                            ? myUrlWithParams.search
                            : myUrlWithParams.href
                );
            }

            SearchRequest(config);
            createCookie('previousUrl', window.location.href, 0.2);
        });
        var mainSearchButton = document.getElementById(
            config.domElements.mainPageSearch.searchButton );
        if ( !! mainSearchButton ) {
            /* enables search input when namespace selected */
            document.addEventListener( 'click', function ( e ) {
                if ( e.target.getAttribute( 'name' ) !== 'namespace' ) {
                    return true;
                }
                document.getElementById(
                    config.domElements.mainPageSearch.inputId )
                    .removeAttribute( 'disabled' );
            } );

            mainSearchButton.addEventListener( 'click', function ( e ) {
                e.preventDefault();
                initMainPageSearch();
            } );
        }
        /*
        $.each(config.pages, (index, item) => {
            if(document.getElementById(config.domElements.mainPageSearch["searchOn_" + index]) !== null){
                document.getElementById(config.domElements.mainPageSearch["searchOn_" + index]).addEventListener("click", (e) => {
                    e.preventDefault();
                    if(validateMainPageSearchInput()){
                        window.location = item + "?search=" + document.getElementById('nnp_search2').value;
                    }
                })
            }
        });
         */
    }

    function loadForm() {
        var urlParamTerm = Common.getUrlParam( 'search', window.location );
        $( '#nnp_search' ).val(urlParamTerm);
        var $form = $( config.domElements.searchForm );
        $( '#nnp_search' ).select2( {
            theme: $form.data( 'action' ),
            tags: true,
            tokenSeparators: ['|'],
            width: 'resolve',
            minimumInputLength: 1,
            dropdownPosition: 'below',
            language: {
                inputTooShort: function () {
                    return null;
                }, searching: function () {
                    return 'Keresés…';
                }
            },
            data: !! urlParamTerm ? [
                {
                    id: urlParamTerm, text: urlParamTerm
                }
            ] : [ { id: '', text: '' } ],
            ajax: {
                url: $form.data( 'ajax-url' ) + '/' + $form.data( 'action' ),
                type: 'POST',
                delay: 1000,
                dataType: 'JSON', data: function ( params ) {
                    var extraFilter = !! memorialClass ? {
                        nnp_search_types: [
                            {
                                type: 'memorial_classification_type',
                                items: [ memorialClass ]
                            }
                        ]
                    } : {};
                    return {
                        action: $form.data( 'action' ),
                        extra_filter: JSON.stringify( extraFilter ),
                        object_type: config.objectType,
                        search: params.term || '',
                        locale: config.locale,
                        page: params.page || 1,
                        limit: 50,
                        order_field: 'relevance',
                        order_type: 'asc'
                    };
                },
                processResults: function ( result ) {
                    if ( ! result.data || ! result.data.items ) {
                        return null;
                    }

                    var results = result.data.items.map( function ( item ) {
                        if ( ! item.nameList || item.nameList.length === 0 ) {
                            return false;
                        }

                        var active = item.nameList.find( function ( names ) {
                            return names.active === 1;
                        } );

                        if ( ! active ) {
                            return false;
                        }

                        return { id: active.title, text: active.title };
                    } );

                    results = results.filter( function ( value, index, self ) {
                        return index === self.findIndex( function ( t ) {
                            return t.id === value.id && t.text === value.text;
                        } );
                    } );

                    return { results: results || [] };
                }
            },
            createTag: function ( tag ) {
                return { id: tag.term, text: tag.term, tag: true };
            },
            templateSelection: function ( data ) {
                if ( data.id === '' ) {
                    $('#nnp_search').addClass('with-placeholder');
                    return 'Indítson szabad szavas keresést vagy a + gombra' +
                        ' kattintva válasszon keresési kategóriát.';
                }
                $('#nnp_search').removeClass('with-placeholder');

                return data.text;
            }
        } ).on( 'select2:opening', function ( e ) {
            $( e.target )
                .html( '<option></option>' )
                .trigger( 'change.select2' );
        } ).on( 'change', function () {
            setTimeout( function () {
                $( '#nnp_search_submit' ).focus();
            }, 1 );
        } );
    }

    function initMainPageSearch() {
        var namespace = document.querySelector(
            config.domElements.mainPageSearch.radioSelector );

        /* return if no namespace selected */
        if ( ! namespace || ! validateMainPageSearchInput() ) {
            return true;
        }

        /* redirect with search term */
        window.location = config.pages[ namespace.value ] +
            '?search=' +
            ( document.getElementById(
                config.domElements.mainPageSearch.inputId ).value || '' );
    }

    function validateMainPageSearchInput() {
        var searchInput = $('#' + config.domElements.mainPageSearch.inputId);
        searchInput.removeClass("ui-state-error");
        searchInput.parent().children(".nnp_error_message").remove();
        /*
        if(searchInput.val().length < 2){
            searchInput.addClass("ui-state-error");
            searchInput.parent().append('<div class="nnp_error_message">A keresési feltételnek minimum 2 karakter hosszúnak kell lennie. Vagy vegyen fel további szűrési feltételt.</div>');
            return false;
        }
         */
        return true;
    }

    function validateForm() {
        return checkSearchInput() && checkCustomSearchInputs();
    }

    function checkSearchInput() {
        var hasFilterType = false;
        var searchInput = $(config.domElements.searchInput);
        var toCheckTypes = ["map", "timeline"];
        searchInput.removeClass("ui-state-error");
        searchInput.parent().children(".nnp_error_message").remove();
        if ($(config.domElements.wrapperSelector).children().length != 0) {
            $("#customSearchWrapper select").each(function (index, item) {
                if ($(item).hasClass("filter_options") && $.inArray($(item).parent().prev().val(), toCheckTypes) <= 0) {
                    hasFilterType = true;
                    return;
                }
            });
        }
        /*
        if (hasFilterType == false && searchInput.val().length < 2) {
            searchInput.addClass("ui-state-error");
            searchInput.parent().append('<div class="nnp_error_message">A keresési feltételnek minimum 2 karakter hosszúnak kell lennie. Vagy vegyen fel további szűrési feltételt.</div>');
            return false;
        }
         */
        return true;
    }

    function checkCustomSearchInputs() {
        var validInput = true;
        if ($(config.domElements.wrapperSelector).children().length != 0) {
            $("#customSearchWrapper input").each(function (index, item) {
                if ($(item).hasClass("filter_input")) {
                    $(item).parent().children(".nnp_error_message").remove();
                    if ($(item).val().length == 0) {
                        if ($(item).parent().prev().val() == "parent") {
                            $(item).addClass("ui-state-error");
                            $(item).parent().append('<div class="nnp_error_message">Válasszon ki egy felettest.</div>');
                            validInput = false;
                        /*
                        } else if ($(item).val().length < 2) {
                            $(item).addClass("ui-state-error");
                            $(item).parent().append('<div class="nnp_error_message">A keresési feltételnek minimum 2 karakter hosszúnak kell lennie.</div>');
                            validInput = false;
                         */
                        }
                    }
                }
            });
        }
        return validInput;
    }
}

( function ( $ ) {

    var Defaults = $.fn.select2.amd.require( 'select2/defaults' );

    $.extend( Defaults.defaults, {
        dropdownPosition: 'auto'
    } );

    var AttachBody = $.fn.select2.amd.require( 'select2/dropdown/attachBody' );

    var _positionDropdown = AttachBody.prototype._positionDropdown;

    AttachBody.prototype._positionDropdown = function () {

        var $window = $( window );

        var isCurrentlyAbove = this.$dropdown.hasClass(
            'select2-dropdown--above' );
        var isCurrentlyBelow = this.$dropdown.hasClass(
            'select2-dropdown--below' );

        var newDirection = null;

        var offset = this.$container.offset();

        offset.bottom = offset.top + this.$container.outerHeight( false );

        var container = {
            height: this.$container.outerHeight( false )
        };

        container.top = offset.top;
        container.bottom = offset.top + container.height;

        var dropdown = {
            height: this.$dropdown.outerHeight( false )
        };

        var viewport = {
            top: $window.scrollTop(),
            bottom: $window.scrollTop() + $window.height()
        };

        var enoughRoomAbove = viewport.top < ( offset.top - dropdown.height );
        var enoughRoomBelow = viewport.bottom >
            ( offset.bottom + dropdown.height );

        var css = {
            left: offset.left, top: container.bottom
        };

        // Determine what the parent element is to use for calciulating the
		// offset
        var $offsetParent = this.$dropdownParent;

        // For statically positoned elements, we need to get the element
        // that is determining the offset
        if ( $offsetParent.css( 'position' ) === 'static' ) {
            $offsetParent = $offsetParent.offsetParent();
        }

        var parentOffset = $offsetParent.offset();

        css.top -= parentOffset.top;
        css.left -= parentOffset.left;

        var dropdownPositionOption = this.options.get( 'dropdownPosition' );

        if ( dropdownPositionOption ===
            'above' ||
            dropdownPositionOption ===
            'below' ) {
            newDirection = dropdownPositionOption;
        } else {

            if ( ! isCurrentlyAbove && ! isCurrentlyBelow ) {
                newDirection = 'below';
            }

            if ( ! enoughRoomBelow && enoughRoomAbove && ! isCurrentlyAbove ) {
                newDirection = 'above';
            } else if ( ! enoughRoomAbove &&
                enoughRoomBelow &&
                isCurrentlyAbove ) {
                newDirection = 'below';
            }

        }

        if ( newDirection == 'above' ||
            ( isCurrentlyAbove && newDirection !== 'below' ) ) {
            css.top = container.top - parentOffset.top - dropdown.height;
        }

        if ( newDirection != null ) {
            this.$dropdown
                .removeClass(
                    'select2-dropdown--below select2-dropdown--above' )
                .addClass( 'select2-dropdown--' + newDirection );
            this.$container
                .removeClass(
                    'select2-container--below select2-container--above' )
                .addClass( 'select2-container--' + newDirection );
        }

        this.$dropdownContainer.css( css );

    };

} )( window.jQuery );
